import { DUPLICATE_MEAL_IN_MEALPLAN } from './actionTypes';

export default (meal, date) => ({
  type: DUPLICATE_MEAL_IN_MEALPLAN,
  payload: {
    meal,
    date,
  },
});